(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/modal/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/modal/assets/javascripts/prescript.js');

(function(svs) {
  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.react_modal = {};
})(svs);


 })(window);